import React from 'react';
import classes from './ResourceCardBanner.module.scss';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const ResourceCardBanner = ({ children, className, ...props }) => {
  return (
    <Row>
      <Col xs={12}>
        <div className={`${classes.resourceCardBanner} ${className}`}>{children}</div>
      </Col>
    </Row>
  );
};

export default ResourceCardBanner;
